import {map, switchMap, tap} from 'rxjs/operators';
import {Injectable, Injector, runInInjectionContext} from '@angular/core';
import {
    collection,
    collectionData,
    doc,
    DocumentReference,
    Firestore,
    getDocs,
    query,
    where
} from '@angular/fire/firestore';
import {BehaviorSubject, of} from 'rxjs';
import {Settings} from '../interfaces/settings';
import {calculateCustomerFromHostname} from '../util';
import {AuthService} from './auth.service';



@Injectable({providedIn: 'root'})
export class ConfigService {

    private _settings$ = new BehaviorSubject<Settings>(null);
    private readonly cDR: DocumentReference;

    constructor(private firestore: Firestore, private authService: AuthService, private injector: Injector) {

        const CUSTOMER_DOMAIN = calculateCustomerFromHostname(document.location.hostname);
        console.log('Configservice setting customerDocumentReference. Domain inferred from the URL: ', CUSTOMER_DOMAIN);
        this.cDR = doc(this.firestore, 'Customers', CUSTOMER_DOMAIN);

        // Subscribe to Settings
        this.authService.userStream$
            .pipe(switchMap(user => {
                console.log('User in ConfigService: ', user);
                if (user) {
                    return runInInjectionContext(this.injector, () => {
                        const settingsColl = collection(this.cDR, 'Settings');
                        const q = query(settingsColl, where('latest', '==', true));
                        return collectionData(q).pipe(
                            map((aat: any) => aat[0]),
                            tap((sett) => console.log('Settings have changed!', sett)));
                    });
                } else {
                    return of(null);
                }
            })).subscribe(this._settings$);

    }

    get settings(): BehaviorSubject<Settings> {
        return this._settings$;
    }

    public getUserDashboardLink = (useremail: string) => {
        const q = query(collection(this.cDR, 'DashboardLinks'), where('email', '==', useremail));
        return getDocs(q);
    }

}
